export const SPECIAL_CONDITIONS_ENDPOINTS = {
    specialConditions: '/investment/documents/special-conditions',
};
